import React, { useState , useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPenToSquare,
  faSave,
  faXmark,
  faLanguage, faCheck
} from "@fortawesome/free-solid-svg-icons";
import Modal from "@/components/Modal";
import { useDispatch, useSelector } from "react-redux";
import { fetchOptionListData } from "@/slices/LocationSlice/optionSlice";
import SearchInput from "@/components/SerachInput"; 
import SingleOptionListTrans from "./SingleOptionListTrans";
import { fetchLanguageList } from "@/slices/panelSlice/languageSlice";
import SingleAddOptionList from "./SingleAddOptionList";
import PageSizeSelector from "@/components/PageSizeSelector";
import SimplePagination from "@/components/SimplePagination";
import {
  fetchVariableList,
  updateVariableList,
} from "@/slices/panelSlice/variableListSlice";

function ViewOptionListTable({ options  , currId}) {
  const dispatch = useDispatch();
  const languageList = useSelector((state) => state.language);
  const { optionList } = useSelector((state) => state.option);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [filteredLangList, setFilteredLangList] = useState([]);
  const [translateModal, setTranslateModal] = useState(false);
  const [singleData , setSingleData] = useState()
  const [Title , setTitle] = useState()
  const [addOptionsDis, setAddoptionsDis] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
const [pageSize, setPageSize] = useState(10);
  
//  console.log(options)

  useEffect(() => {
  setFilteredLangList(options || []);
}, [options]);

 useEffect(() => {
    dispatch(fetchLanguageList());
    dispatch(fetchOptionListData());
  }, [dispatch]);



  // total pages
const totalPages = Math.ceil(filteredLangList.length / pageSize);

// paginated data
const paginatedData = filteredLangList.slice(
  (currentPage - 1) * pageSize,
  currentPage * pageSize
);


useEffect(() => {
  setCurrentPage(1);
}, [filteredLangList]);

const handleEdit = (row) => {
  setEditRowId(row.id);

  const matchedOption = optionList?.result?.find(
    (item) => item.title === row.optionType
  );

  setEditedData({
    id: row.id,
    title: row.title,
    val: row.val,
    status: row.status,
    optionType: matchedOption?.id || "", // ✅ ALWAYS ID
  });
};


  const handleChange = (e, field) => {
    setEditedData({
      ...editedData,
      [field]: e.target.value,
    });
  };

  const handleSave = async () => {
    const { id, title, val, optionType, status } = editedData;
    
    const updatedData = {
      id: currId,
      option_List: [{ id, title, optionType: Number(optionType), val, status }],
    };
    
    console.log(updatedData , "updatedData")

    const resp = await dispatch(updateVariableList(updatedData));
    if (!resp.error) {
      const newResp = await dispatch(fetchVariableList());
    }

    setEditRowId(null);
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const handleTranslationClick = (row) => {
    setTranslateModal(true)
    setSingleData(row)
    setTitle(row?.title)
    // console.log("Open translation for:", row);
  };


   const handleAddOptionList = ()=>{
      setAddoptionsDis(true)
  }

  return (
    <div className="mt-2">

      <div className="flex justify-between">
        <SearchInput
        placeholder="Search by title..."
        data={options || []}
        searchKey="title" 
        onSearchResults={setFilteredLangList}
      />
      
      <div className="flex items-center gap-3">

         <PageSizeSelector
          pageSize={pageSize}
         setPageSize={(size) => {
           setPageSize(size);
          setCurrentPage(1);
         }}
    />

       <button
            type="button"
             onClick={handleAddOptionList}
              className="relative bg-blue-500 hover:bg-blue-600 text-white h-[35px] px-3 rounded-lg border shadow-sm text-xs">
              Add Option List
          </button>

      </div>

        
      </div>
      <div className="overflow-x-auto border rounded-lg max-h-[350px] overflow-y-auto">

        <table className="min-w-full text-sm text-left">

          {/* HEADER */}
          <thead className="bg-gray-100 text-gray-700 text-xs uppercase sticky top-[-1px]">
            <tr>
              <th className="px-4 py-2 border text-center">Translate</th>
              <th className="px-4 py-2 border">Title</th>
              <th className="px-4 py-2 border">Code</th>
              <th className="px-4 py-2 border">Type</th>
              <th className="px-4 py-2 border">Order</th>
              <th className="px-4 py-2 border">Value</th>
              <th className="px-4 py-2 border">Status</th>
              <th className="px-4 py-2 border text-center">Action</th>
            </tr>
          </thead>

          {/* BODY */}
          <tbody>
            {paginatedData.length > 0 ? (
              paginatedData.map((opt) => (
                <tr key={opt.id} className="border-b hover:bg-gray-50">

                       {/* Translate ICON */}
                  <td  className="px-4 py-2 border text-center">
                    <FontAwesomeIcon
                      icon={faLanguage}
                      className="cursor-pointer text-gray-600 hover:text-blue-500"
                      onClick={() => handleTranslationClick(opt)}
                    />
                  </td>

                  {/* Title */}
                  <td className="px-4 py-2 border">
                    {editRowId === opt.id ? (
                     <input
                      value={editedData.title || ""}
                      onChange={(e) => handleChange(e, "title")}
                      className="w-[160px] border px-2 py-1 rounded"
                    />
                    ) : (
                      opt.title || "--"
                    )}
                  </td>

                  {/* Code */}
                  <td className="px-4 py-2 border">
                    {editRowId === opt.id ? (
                       opt.code || "--"
                    ) : (
                      opt.code || "--"
                    )}
                  </td>

                  {/* Type */}
                 <td className="px-4 py-2 border">
              {editRowId === opt.id ? (
                <select
                value={editedData.optionType}
                  onChange={(e) => handleChange(e, "optionType")}
                 className="w-full min-w-[160px] border px-2 py-1 rounded"
                >
                  <option value="">Select Type</option>

                  {optionList?.result?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.title}
                    </option>
                  ))}
                </select>
              ) : (
                opt.optionType || "--"
              )}
            </td>

                  {/* Order */}
                  <td className="px-4 py-2 border">
                    {editRowId === opt.id ? (
                   
                       opt.order || "--"
                    ) : (
                      opt.order || "--"
                    )}
                  </td>

                  {/* Value */}
                  <td className="px-4 py-2 border">
                    {editRowId === opt.id ? (
                    <input
                      value={editedData.val || ""}
                      onChange={(e) => handleChange(e, "val")}
                      className="w-[140px] border px-2 py-1 rounded"
                    />
                    ) : (
                      opt.val || "--"
                    )}
                  </td>

                        <td className="px-4 py-2 border text-center">
                      {editRowId === opt.id ? (
                        <FontAwesomeIcon
                          icon={editedData.status ? faCheck : faXmark}
                          className={`cursor-pointer ${
                            editedData.status ? "text-green-600" : "text-red-500"
                          }`}
                          onClick={() =>
                            setEditedData((prev) => ({
                              ...prev,
                              status: !prev.status,
                            }))
                          }
                        />
                      ) : opt.status === true ? (
                        <FontAwesomeIcon icon={faCheck} className="text-green-600" />
                      ) : opt.status === false ? (
                        <FontAwesomeIcon icon={faXmark} className="text-red-500" />
                      ) : (
                        "--"
                      )}
                    </td>

                  {/* ACTION */}
                  <td className="px-4 py-2 border text-center">
                    {editRowId === opt.id ? (
                      <div className="flex justify-center gap-3">
                        <FontAwesomeIcon
                          icon={faSave}
                          className="cursor-pointer text-green-600"
                          onClick={handleSave}
                        />
                        <FontAwesomeIcon
                          icon={faXmark}
                          className="cursor-pointer text-red-500"
                          onClick={handleCancel}
                        />
                      </div>
                    ) : (
                      <FontAwesomeIcon
                        icon={faPenToSquare}
                        className="cursor-pointer"
                        onClick={() => handleEdit(opt)}
                      />
                    )}
                  </td>

                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center py-4 text-gray-500">
                  No option data available
                </td>
              </tr>
            )}
          </tbody>

        </table>
        
      

      </div>


        {filteredLangList.length > 0 && (
          <div className="mt-3">
            <SimplePagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalPages={totalPages}
            />
          </div>
        )}

        <Modal
         isOpen={translateModal}
         onClose={() => setTranslateModal(false)}
         title={`Translate Option  ${Title}`}
         content={
          <SingleOptionListTrans
           currId={currId}
           singleData={singleData}
            langList={languageList?.data?.result} 
           />
       }
    />


      <Modal
         isOpen={addOptionsDis}
         onClose={()=>setAddoptionsDis(false)}
         title="Add More Option "
         content={
         <SingleAddOptionList 
              Close={() => setAddoptionsDis(false)}
              currId = {currId}
          /> 
        }
      />
    </div>
  );
}

export default ViewOptionListTable;